import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import uploader from 'vue-simple-uploader';
import Vuelidate from 'vuelidate';

Vue.use(VueScrollTo);
Vue.use(uploader);
Vue.use(Vuelidate);

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}
